import React from 'react';

import { UiFilterSelect } from '../../ui/ui-filter-select';
import { UiFilterToggle } from '../../ui/ui-filter-toggle';

type Props = {
  responsesToShow: string;
  displayIrrelevant: boolean;
  setDisplayIrrelevant: any;
  setResponsesToShow: any;
};

export const EmployeeSurveyDetailFilter = ({
  responsesToShow,
  displayIrrelevant,
  setDisplayIrrelevant,
  setResponsesToShow,
}: Props) => {
  const handleFilterSelect = (filterByResponseType: string) =>
    setResponsesToShow(filterByResponseType || 'ALL');
  const handleResponseFilter = () => setDisplayIrrelevant(!displayIrrelevant);

  return (
    <div className="card u-margin-top-xl u-margin-bottom u-spread">
      <div className="card-body u-display-flex u-alignItems-flexStart">
        <UiFilterSelect
          hideClear
          label="Employee Response Status"
          className="u-margin-left"
          value={responsesToShow}
          onChange={handleFilterSelect}
          options={[
            { value: 'ALL', label: 'All Employees' },
            { value: 'RESPONDED', label: 'Have Responded' },
            { value: 'NOT_RESPONDED', label: "Haven't Responded" },
            { value: 'FAILED', label: 'Failed to send' },
          ]}
        />
        <UiFilterToggle
          label={`${displayIrrelevant ? 'Exclude' : 'Include'} Hidden Responses`}
          value={displayIrrelevant}
          onChange={handleResponseFilter}
          className="u-margin-left"
        />
      </div>
    </div>
  );
};
